import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SuitDiamond.svg",
  "use": "SuitDiamond.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"SuitDiamond.svg\"><path d=\"M30.674,8.9642a1.4206,1.4206,0,0,1,2.6728,0c3.3168,8.6589,12.6578,17.9221,17.8688,21.5334a1.8645,1.8645,0,0,1,0,3.0545c-5.211,3.6112-14.552,12.8744-17.8688,21.5333a1.4206,1.4206,0,0,1-2.6728,0c-3.3168-8.6589-12.6574-17.9221-17.8684-21.5333a1.8645,1.8645,0,0,1,0-3.0545C18.0166,26.8863,27.3572,17.6231,30.674,8.9642Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol